export default __webpack_public_path__ + "static/maxwax-35e56b75da6890029585851f7056fec8.png";